<template>
<div>
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
 <!-- {{leave_approval_authority_list}} -->
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Appoint Authority
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row class="row" dense>
                <v-col cols="4">
                          <v-autocomplete rounded
                    outlined
                    dense
                            v-model="editedItem.employeeType"
                            :items="employee_type_list"                            
                            item-text="name"
                            item-value="id"
                            label="Employee Type"                         
                            :filled="editedIndex==-1?false:true"                            
                            single-line
                            return-object
                            @change="getEmployeeList(editedItem.employeeType)"
                            ></v-autocomplete>
                </v-col>

                <v-col cols="4">
                  <v-autocomplete
                    v-model="editedItem.employee"
                    :items="employee_list"                    
                    label="Employee"
                    multiple
                    :rules="[v => !!v || 'required']"
                    item-text="showname"
                    item-value="id"
                    rounded
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
<!--
                <v-col cols="4">
                          <v-select 
                            dense
                            v-model="editedItem.employee"
                            :items="employee_list"
                            :rules="[v => !!v || 'required']"
                            item-text="employee_code"
                            item-value="id"
                            label="Employee"                         
                            :filled="editedIndex==-1?false:true"
                            return-object
                            single-line 
                            muitiple                           
                            ></v-select>
                </v-col>
-->
                <v-col cols="4">
                          <v-autocomplete rounded
                    outlined
                    dense
                            v-model="editedItem.leaveApprovalAuthority"
                            :items="leave_approval_authority_list"
                            :rules="[v => !!v || 'required']"
                            item-text="authority"
                            item-value="id"
                            label="Approval Authority"                         
                            :filled="editedIndex==-1?false:true"                            
                            single-line                                                        
                            ></v-autocomplete>
                </v-col>
            </v-row>

            <v-row>
                <v-col justify="center">                   
                    <v-btn color="mb-2 button"  @click="save" >Save</v-btn>
                    <!--:disabled="!valid"-->
                </v-col>    
            </v-row>

        </v-card>
  <v-data-table
    :headers="headers"
    :items="appointed_authority_list"
    class="elevation-1 box"
     :search="search"
  >
  
    <template v-slot:top>
      <v-toolbar flat color="white">
       <!-- <v-toolbar-title>Appoint Authority</v-toolbar-title>
        
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider> 
        <v-spacer></v-spacer>-->
        <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details>
          </v-text-field>
          <span style="width: 20px"></span>
        <v-dialog v-model="dialog" max-width="500px">
        <!--
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">Add Appoint Authority</v-btn>
          </template>
        -->
          <v-card>
            <v-form v-model="valid">
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>

                        <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="editedItem.employee" 
                            persistent-hint                        
                            label="Employee"                           
                            readonly
                            disabled
                            rounded
                    outlined
                    dense
                            >
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <v-select rounded
                    outlined
                    dense
                            v-model="editedItem.leaveApprovalAuthority"
                            :items="leave_approval_authority_list"
                            :rules="[v => !!v || 'required']"
                            item-text="authority"
                            item-value="id"
                            label="Approval Authority"                         
                            :filled="editedIndex==-1?false:true"
                            return-object
                            single-line                                                        
                            ></v-select>
                </v-col>

                </v-row>               
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="mb-2 button" text @click="close">Cancel</v-btn>
              <v-btn color="mb-2 button"  @click="save" :disabled="!valid">Save</v-btn>
            </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>        
      </v-toolbar>
    </template>

    <template v-slot:item.isactive="{ item }">
            <span v-if="item.isactive">
                <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
                <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
        </template>
    <!--           
    <template v-slot:item.action="{ item }">
     <div>
        <v-avatar style="" size="25" class="edit-avatar">
          <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
       </v-avatar>
      </div>
    </template>
   -->
  </v-data-table>
   <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</div>
</template>

<script>
import axios from 'axios'
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  export default {
    data: () => ({
      valid: false,
      overlay:false,
    errorMsg: {
      castId: false
    },
    menu:'',
    menu1:'',
    emenu:'',
    emenu1:'',
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search:'',
      dialog: false,
      headers: [
          {
          text: 'Employee Code',
          align: 'left',
          sortable: false,
          value: 'employee_code',
        }, 
        {
          text: 'Employee Name',
          align: 'left',
          sortable: false,
          value: 'fullname',
        }, 
        {
          text: 'Authority',
          align: 'left',
          sortable: false,
          value: 'leaveapporvalauthority',
        },   
        /*       
        { text: 'Actions', value: 'action', sortable: false },
        */
      ],
      leave_approval_authority_list: [],      
      employee_type_list:[],
      appointed_authority_list:[],
      employee_list:[],
      editedIndex: -1,
      editedItem: {
        markLeaveApprovalAuthorityId: '',         
        employee:[],
        leaveApprovalAuthority:'',        
      },
      defaultItem: {
        markLeaveApprovalAuthorityId: '',         
        employee:[],
        leaveApprovalAuthority:'',        
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Appoint Authority' : 'Edit Appoint Authority'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      overlay (val) {
        val = () => {
          this.overlay = false
        };
      },
    },
    mounted(){
      this.onLoad()       
     },
    methods: {
        getEmployeeList(item){           
         axios
              .post("/LeaveManagement/getEmployees", item)
              .then(res => {                     
                 this.employee_list =res.data.employee_list
              })
              .catch(error => {
                window.console.log(error);
              });
        },
    initializeErrorMsgFalse() {
      this.errorMsg.castId = false;
    },

    onLoad(){      
      this.overlay=true;
          axios
      .post("/LeaveManagement/getApprovalAuthority")
      .then(res => {
        if (res.data.msg == "200") {
          if(this.load = true){
            this.overlay=false;    
            this.appointed_authority_list = res.data.appointed_authority_list;        
            this.employee_type_list = res.data.employee_type_list;           
            this.leave_approval_authority_list = res.data.leave_approval_authority_list;           
          }
        } else {
        }
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        //window.console.log("Errro------>"+error);
      })
      .finally(()=>{ 
        var overlay=false;
      });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem (item) {        
        //window.alert(JSON.stringify(item))
        this.editedIndex = this.appointed_authority_list.indexOf(item)        
        this.dialog = true        
        this.editedItem.markLeaveApprovalAuthorityId = item.id       
        this.editedItem.employee = item.employee_code
        this.editedItem.leaveApprovalAuthority = item.leaveapporvalauthority
        //window.alert(JSON.stringify(this.editedItem))
    },

      // deleteItem (item) {
      //   const index = this.language_super_master_list.indexOf(item)
      //   confirm('Are you sure you want to delete this item?') && this.language_super_master_list.splice(index, 1)
      // },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save() {              
          if (this.editedIndex > -1) 
          {
            if (this.isValidated()) {
                    if(this.editedItem.leaveApprovalAuthority == null || this.editedItem.leaveApprovalAuthority == ''  || this.editedItem.leaveApprovalAuthority == 'null'){
                    this.showSnackbar("#b71c1c", "Please Select Atleast 1 Authority")
                }
                    else{
                      window.alert("Editing")
                        axios
                        .post("/LeaveManagement/editApprovalAuthority", this.editedItem)
                        .then(res => {
                            if (res.data.status.code == "SUCCESS") {                 
                            this.showSnackbar(
                                "#4caf50",
                                "Authority Updated Successfully..."
                            ); // show snackbar on success
                            this.onLoad();
                            }
                            else if (res.data.status.code == "NA") {
                            this.showSnackbar("#b71c1c", "Authority Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch(error => {
                            window.console.log(error);
                        });
                        this.close();
                    }
            }
            } 
        else 
        {                      
                if(this.editedItem.employee == null || this.editedItem.employee == ''  || this.editedItem.employee == 'null'){
                    this.showSnackbar("#b71c1c", "Please Select Employee")
                }
                else if(this.editedItem.leaveApprovalAuthority == null || this.editedItem.leaveApprovalAuthority == ''  || this.editedItem.leaveApprovalAuthority == 'null'){
                    this.showSnackbar("#b71c1c", "Please Select Atleast 1 Authority")
                } else{
                    axios
                    .post("/LeaveManagement/saveApprovalAuthority", this.editedItem)
                    .then(res => {
                        if (res.data.status.code == "SUCCESS") {      
                        this.showSnackbar("#4caf50", "Authority Added Successfully..."); // show snackbar on success
                        this.onLoad()
                        } else if (res.data.status.code == "NA") {
                        this.showSnackbar("#b71c1c", "Authority Already Present,Please Edit..."); // show snackbar on error
                        }
                    })
                    .catch(error => {
                        window.console.log(error);
                    });

                    this.close(); 
                }     
        }
      }, // end of save()

      isValidated() {
        if (this.editedItem.markLeaveApprovalAuthorityId) {
          return true;
        } else {
          if (!this.editedItem.markLeaveApprovalAuthorityId) {
            this.errorMsg.markLeaveApprovalAuthorityId = true;
          }
          return false;
        }
      } // .....end of isValidated()
    },
  }
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}

.tc-title {
        background-image: linear-gradient(-90deg, #fff, blue);
        color: #fff;
        border-radius: 3px;
    }

    .table-head {
    background: #0f2027; /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    color: white  !important;
    }
    .textcolor{
        color: darkblue;
        font-weight: bold;
    }
      td,
    th {
        border: 1px solid #ccc;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        font-weight: bold;
    }
    td{
        margin: 1rem !important;
        padding: 1rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
sub-row {
        border: 2px solid #424093;
        margin: 1rem;
        border-radius: 5px;
    }

    i {
        font-size: 20px !important;
    }

    .v-card__title {
        border: 1px solid #80808040;
        font-weight: bold;
        background-color: #424093;
        color: white;
        text-align: center;
        /* margin-top: 1.5rem; */
    }
    .card-border {
        border: 2px solid darkblue;
        border-radius: 10px;
        /* padding: 5px; */
        /* margin: 1rem !important; */
        width: auto;
    }

    .tx-bold {
        font-weight: bold;
        font-size: 14px;
        color: black;
    }

    i {
        font-size: 26px;
        cursor: pointer;
    }

    theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: #424093 !important;
        color: white !important;
        margin-top: 2.35rem;
        border-radius: 20px;
    }

    /*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

    @media only screen and (max-width: 600px) {
    }

    .imgs {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: 150px;
        cursor: zoom-in;
    }

    .imgs-preview {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: auto;
    }

    v-simple-table {
        border-collapse: collapse;
        border-spacing: 0;
        width: auto;
        border: 1px solid #ddd;
    }

    th {
        color: white;
        font-weight: bold;
        text-align: center !important;
    }

    td,
    th {
        padding: 6px;
        border: 1px solid #ccc;
        text-align: center;
    }
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }

    @media all and (min-width: 1000px) {
        .padding-metting {
            padding-right: 22px;
        }
    }
    @media (min-width: 320px) and (max-width: 350px) {
        .padding-bot {
            font-size: 11.6px;
        }
    }
    @media (min-width: 1000px) and (max-width: 1050px) {
        .padding-bot {
            font-size: 9.6px;
        }
    }
     .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }

</style>